export const DATE_FORMAT_INPUT: string = "YYYY-MM-DD";
export const DATE_FORMAT_DISPLAY: string = "MMM DD, YYYY";
export const TIME_FORMAT_INPUT: string = "HH:mm:ss";
export const DATETIME_FORMAT_INPUT: string = "YYYY-MM-DD HH:mm:ss";
export const DATETIME_FORMAT_DISPLAY: string = "MMM DD, YYYY HH:mm A";
export const DATETIME_FORMAT_DISPLAY_2: string = "MM/DD/YYYY | HH:mm:ss";
export const DATETIME_FORMAT_DISPLAY_3: string = "DD/MM/YYYY | HH:mm:ss";
export const DATETIME_FORMAT_DISPLAY_4: string = "MM/DD/YYYY | hh:mm A";
